import {
  Component,
  OnInit,
  ChangeDetectorRef,
  ChangeDetectionStrategy
} from "@angular/core";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { ENTER, COMMA } from "@angular/cdk/keycodes";
import { MatDialogRef } from "@angular/material";
import { MatChipInputEvent } from "@angular/material/chips";
import { BaseDialog } from "src/app/base-dialog";
import { RelatorioService } from "../../services/relatorio.services";
import { AuthService } from "src/app/services/ajs-auth.service";

@Component({
  selector: "mandae-relatorio-automatizado-criar",
  templateUrl: "./criar-relatorio.component.html",
  styleUrls: ["./criar-relatorio.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ModalCriarComponent extends BaseDialog<ModalCriarComponent>
  implements OnInit {
  public isLoaded = false;

  public currentCliente: any = [];

  public formulario: FormGroup;

  readonly separatorKeysCodes: number[] = [ENTER, COMMA];

  public emails = [];

  public selectable = true;

  public removable = true;

  public addOnBlur = true;

  public periodicidadeEnvio = null;

  constructor(
    dialogRef: MatDialogRef<ModalCriarComponent>,
    public relatorioService: RelatorioService,
    public authService: AuthService,
    public cr: ChangeDetectorRef
  ) {
    super(dialogRef);

    this.formulario = new FormGroup({
      nome: new FormControl(null, Validators.required),
      contas: new FormControl(),
      email: new FormControl(null, Validators.email),
      periodicidade: new FormControl(Validators.required),
      situacao: new FormControl("", Validators.required),
      periodicidadeEnvio: new FormControl(),
      mensal: new FormControl(),
      semanal: new FormControl()
    });
  }

  public ngOnInit() {
    this.verificaContaPai();
  }

  public async verificaContaPai() {
    try {
      const data = await this.relatorioService.consultaClientePrincipal(
        this.authService.getCurrentUser()
          ? this.authService.getCurrentUser().id
          : 0
      );

      this.currentCliente = data;

      if (data.contas_vinculadas.length) {
        this.formulario.get("contas").setValidators(Validators.required);
      } else {
        this.formulario.get("contas").setValue(this.currentCliente.email);
      }

      this.isLoaded = true;

      this.cr.markForCheck();
    } catch (error) {}
  }

  public adicionarEmail(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    const valid = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g.test(value);

    if (valid) {
      if ((value || "").trim()) {
        this.emails.push({ name: value.trim() });
      }

      if (input) {
        input.value = "";
      }
    }
  }

  public removerEmail(email: any): void {
    const index = this.emails.indexOf(email);

    if (index >= 0) {
      this.emails.splice(index, 1);
    }
  }

  public handleChangePeriodicidadeEnvio(event: any) {
    this.periodicidadeEnvio = event.target.value;
  }

  public async criarRelatorio() {
    try {
      const agendaDia = {
        dia: this.formulario.value.mensal
      };

      const agendaSemanal = {
        semana: this.formulario.value.semanal
      };

      const contas = `${this.currentCliente.email}${
        this.formulario.value.contas ? "," + this.formulario.value.contas : ""
      }`;

      const relatorio = {
        contas,
        nome: this.formulario.value.nome,
        emailEnvio: this.convertEmailsParaString(),
        periodo: this.formulario.value.periodicidade,
        situacao: this.formulario.value.situacao
          ? this.formulario.value.situacao
          : null,
        agenda: []
      };

      this.formulario.value.periodicidadeEnvio === "mensal"
        ? (relatorio.agenda[0] = agendaDia)
        : (relatorio.agenda[0] = agendaSemanal);

      if (this.formulario.value.periodicidadeEnvio === "diario") {
        relatorio.agenda = [
          {
            semana: "0"
          },
          {
            semana: "1"
          },
          {
            semana: "2"
          },
          {
            semana: "3"
          },
          {
            semana: "4"
          },
          {
            semana: "5"
          },
          {
            semana: "6"
          }
        ];
      }

      if (
        relatorio.nome &&
        relatorio.emailEnvio &&
        relatorio.periodo &&
        relatorio.contas
      ) {
        await this.relatorioService.criarRelatorio(relatorio);
        this.dialogRef.close({ status: true, message: "created" });
      }
    } catch (error) {
      console.log("e", error);
    }
  }

  public fechar() {
    this.dialogRef.close({ status: false, message: "closed" });
  }

  private convertEmailsParaString() {
    const emails = [];

    for (let i = 0; i < this.emails.length; i++) {
      emails.push(this.emails[i].name);
    }

    return emails.join(";");
  }
}
